<template>
    <div class="oin-pay-password">
        <navigation-bar Close/>
        <div class="fixed-more" @click="goPayEdit()" v-if="isHavePayPassword"><i class="el-icon-more"/></div>

        <div class="main text-center">
            <div class="oin-pay-logo">
                <img src="@/assets/images/logo_s.svg" class="logo">
                <img src="@/assets/images/pay/oin-pay-icon.svg" class="pay">
            </div>

            <!--todo 標題文案-->
            <h5>{{title}}</h5>

            <!--todo 6個圈圈＋錯誤提示-->
            <div class="circle-step">
                <div class="circle-block">
                    <div class="bg" v-for="index in 6" :class="{'active':index<=number.length}" :key="index"/>
                </div>
                <div class="red small mt-4" v-html="feedback"/>
            </div>

            <!--TODO 數字鍵盤-->
            <div class="btn-list">
                <el-button v-for="index in 10" :key="index"
                           @click.native="keyNumber(index-1)"
                           circle>
                    {{index-1}}
                </el-button>
                <el-button type="text" @click.native="[]"
                           @touchstart.native.prevent="tchstart"
                           @touchend.native="tchend"
                           @touchmove.native="tchmove"
                           @mousedown.native.prevent="tchstart"
                           @mouseup.native="tchend">
                    <i class="el-icon-close"/>
                </el-button>
            </div>

        </div>

        <loading
                :active.sync=isLoading
                :can-cancel="false"
                :is-full-page="true"/>

    </div>
</template>

<script>

    import * as constDefine from "@/store/constDefine";
    import {notNull} from "@/util/common";

    export default {
        name: "PayPassword",
        components: {

        },
        data() {
            return {
                dataToken: this.$route.query.dataToken !== undefined ? this.$route.query.dataToken : "",
                dataObject: {},
                //文字標題
                title: '',
                //是否設定過支付密碼
                isHavePayPassword: false,
                isUpdatePayPassword: false,
                //第一次設定支付密碼:true 再次輸入支付密碼:false
                isFirst: true,
                //支付密碼輸入
                number: '',
                loop: 0,
                isLoading: false,
                //回饋錯誤幾次
                feedback: '',
                firstNumber: '',
                userId: 0,
                successRouterName: '',//會用replace執行，避免go(-1
                oinPayName: constDefine.OinPayName,
            }
        },
        created() {
            try {
                let dataObject = this.$crypto.uriComponentToObject(this.dataToken)
                if (dataObject.usedType === this.$route.name) {
                    this.dataObject = dataObject
                    this.isHavePayPassword = this.dataObject.isHavePayPassword || false
                    this.isUpdatePayPassword = this.dataObject.isUpdatePayPassword || false
                    this.successRouterName = this.dataObject.successRouterName || ""

                    let decrypted = this.$crypto.decryptText(this.$auth.getAdminToken());
                    this.userId = Number(decrypted.split(';')[0]);

                    if(this.userId > 0 && this.successRouterName !== "") {
                        if (this.isHavePayPassword) {
                            //已設定過支付密碼
                            this.title = '請輸入支付密碼'
                        } else {
                            //第一次設定支付密碼
                            this.title = '請設定支付密碼'
                        }
                    } else {
                        this.$public.showNotify("參數異常", false);
                        this.$router.push({name: 'More'})
                    }
                } else {
                    this.$public.showNotify("參數異常", false);
                    this.$router.push({name: 'More'})
                }
            } catch (e) {
                this.$public.showNotify("參數異常", false);
                this.$router.push({name: 'More'})
            }
        },
        methods: {
            //密碼輸入完後
            submit() {
                if (this.isHavePayPassword) {
                    this.checkPayPassword()
                } else {
                    if (!this.isFirst) {
                        if (this.firstNumber === this.number) {
                            this.savePayPassword()
                        } else {
                            setTimeout(() => {
                                this.isLoading = false
                                this.firstNumber = ''
                                this.number = ''
                                this.isFirst = true
                                this.title = '請設定支付密碼'
                                this.feedback = "<i class=\"el-icon-warning\"/> 再次輸入密碼和設定密碼不一致"
                            }, 1000)
                        }
                    } else {
                        //再次設定支付密碼
                        setTimeout(() => {
                            this.isLoading = false
                            this.firstNumber = this.number
                            this.number = ''
                            this.isFirst = false
                            this.title = '請再次輸入支付密碼'
                        }, 1000)
                    }
                }
            },
            tchstart() {
                //let self = this
                this.loop = setTimeout(() => {
                    this.loop = 0;
                    //真正长按后应该执行的内容
                    this.number = ''
                }, 500);//这里设置定时器，定义长按500毫秒触发长按事件，时间可以自己改，个人感觉500毫秒非常合适
            },
            tchend() {
                clearTimeout(this.loop);//清除定时器
                if (this.loop !== 0) {
                    //这里写要执行的内容（尤如onclick事件）
                    let numberStr = this.number.toString();
                    this.number = numberStr.substring(0, numberStr.length - 1)
                }
            },
            tchmove() {
                clearTimeout(this.loop);//清除定时器
                this.loop = 0;
            },
            keyNumber(number) {
                //清除回饋錯誤訊息
                if (this.feedback !== '') {
                    this.feedback = ''
                }

                if (this.number.length < 6) {
                    this.number += number
                }

                if (this.number.length === 6) {
                    this.submit()
                    this.isLoading = true
                }
            },
            savePayPassword() {
                this.$http.fetchWithAuthEncrypt`SavePayPassword${{
                    userPayPassword: this.$crypto.encryptText(String(this.number)),
                    userId: this.userId,
                }}
                ${json => {
                    if (json.status) {
                        this.$public.showNotify("支付密碼設定成功", true);
                        this.$router.replace({name: this.successRouterName})
                    } else {
                        this.$public.showNotify(json.message, json.status);
                    }
                    this.isLoading = false
                }}`;
            },
            checkPayPassword() {
                let payPassword = this.$crypto.encryptText(String(this.number))
                this.$http.fetchWithAuthEncrypt`CheckPayPassword${{
                    userPayPassword: payPassword,
                    userId: this.userId,
                }}
                ${json => {
                    if (json.status) {
                        if(this.isHavePayPassword && this.isUpdatePayPassword) {
                            this.isHavePayPassword = false
                            this.firstNumber = ''
                            this.number = ''
                            this.isFirst = true
                            this.title = '請設定支付密碼'
                        } else {
                            let paramsToken = this.$crypto.objectToURIComponent({
                                usedType: this.successRouterName,
                                payPassword: payPassword,
                                validTimestamp: new Date().getTime() + (30 * 1000),
                            })

                            this.$router.replace({name: this.successRouterName, params: {paramsToken: paramsToken}})
                        }
                    } else {
                        if (notNull(json.data)) {
                            let data = json.data;
                            let keyInCount = data.keyInCount;
                            this.number = ''
                            this.feedback = `<i class="el-icon-warning"/> 您已經輸入錯誤第${keyInCount}次，超過5次將自動刪除${this.oinPayName}`
                            if (keyInCount >= 5) {
                                this.$store.commit("updateCartPaymentType", {});
                                this.$public.showNotify(`您已經輸入錯誤第${keyInCount}次，超過5次將自動刪除${this.oinPayName}`, false, 5000);
                                this.$router.push({name: 'More'})
                            }
                        } else {
                            this.$public.showNotify(json.message, json.status);
                        }
                    }
                    this.isLoading = false
                }}`;
            },
            goPayEdit() {
                let self = this
                let routerName = "PayEdit"
                let dataToken = self.$crypto.objectToURIComponent({
                    usedType: routerName,
                    isHavePayPassword: self.isHavePayPassword,
                    successRouterName: "OINPay",
                })

                self.$router.push({name: routerName, query: {'dataToken': dataToken}})
            },
        }

    }
</script>

<style lang="less" scoped src="../../less/oinPay.less"/>
